import React, { createContext, useContext, useMemo, useState } from 'react';

import { SaveMode } from 'utilities/Enums';

const NodeWorkflowContext = createContext(null);

export const NodeWorkflowProvider = ({ children }) => {
  const [selectedCameraMode, setSelectedCameraMode] = useState('PHOTO');
  const [nodes, setNodes] = useState([]);
  const [editorSaveMode, setEditorSaveMode] = useState(SaveMode.ADD);

  const value = useMemo(() => ({
    selectedCameraMode,
    setSelectedCameraMode,
    nodes,
    setNodes,
    editorSaveMode,
    setEditorSaveMode,
  }), [selectedCameraMode, nodes, editorSaveMode]);

  return (
    <NodeWorkflowContext.Provider value={value}>
      {children}
    </NodeWorkflowContext.Provider>
  );
};

export const useNodeWorkflow = () => {
  const context = useContext(NodeWorkflowContext);
  if (!context) {
    throw new Error('useNodeWorkflow must be used within NodeWorkflowProvider');
  }
  return context;
};

export default NodeWorkflowContext;
